<template>
  <div>
    <v-badge
        v-if="customerLineItems"
        :content="lineItemsSize"
        color="blue"
        overlap>
      <v-btn class="blue--text" outlined @click="lineItemDialog = true">My List</v-btn>
    </v-badge>
    <v-dialog max-width="500" v-model="lineItemDialog">
              <v-card class="elevation-0">
                <v-card-title>My List</v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="customerLineItems">
                  <div v-if="customerLineItems.length !== 0" >
                    <v-list v-for="lineItem in customerLineItems" :key="lineItem.id">
                      <v-list-item two-line >
<!--                        description-->
                        <v-list-item-content>
                          <v-list-item-title>{{lineItem.title}}</v-list-item-title>
                          <v-list-item-subtitle>
                          <span>
                            ${{calcLineItemCost(lineItem)}}
                          </span>
                            <span v-if="lineItem.itemType !== 'service'">
                            Qty: {{lineItem.qty}}
                          </span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn class="red--text" icon @click="removeLineItem(lineItem)"><v-icon>close</v-icon></v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider></v-divider>
                    </v-list>
                    <div class="subtitle-1">Total Cost: ${{totalListCost}}</div>
                  </div>
                  <div v-else class="mt-4">
                    Nothing added
                  </div>
                </v-card-text>
                <v-card-text v-else class="mt-4">
                  <div>
                    Nothing added
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="lineItemDialog = false" text>close</v-btn>
                  <v-btn v-if="lineItemsSize !== 0" :disabled="lineItemsSize === 0"  @click="bookOrder" class="blue mt-2" dark text>Continue to order</v-btn>
                </v-card-actions>
              </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {doc, onSnapshot, updateDoc} from "firebase/firestore";
import { v1 as uuidv1 } from 'uuid';
export default {
  data: () => ({
    lineItemDialog: false,
    customerLineItems: null,
    lineItemsSize: 0,
    publicListingId: null,
    quoteId: uuidv1()
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    totalListCost () {
      let lineItems = this.customerLineItems
      let cost = 0
      if (lineItems) {
        lineItems.forEach(item => {
          cost += +this.calcLineItemCost(item)
          // console.log(cost)
        })
      }
      let costRounded = Number(cost).toFixed(2)
      return costRounded
    },
  },
  created () {
    let db = this.$store.state.db
    // console.log(this.user.uid)
    if (this.user.isAnonymous) {
      let userRef = doc(db, 'anonUsers', this.user.uid)
      return onSnapshot(userRef, res => {
        if (res.exists) {
          let data = res.data()
          this.$store.dispatch('setAnonUserData', data)
          // console.log(data)
          this.publicListingId = data.connectedPublicListingId
          if (data.lineItems) {
            this.customerLineItems = data.lineItems
            this.lineItemsSize = data.lineItems.length
            // console.log(data.lineItems)
          }
          // console.log(this.$store.getters.anonQuoteDetails)
        }

      })
    } else {
      let customerRef = doc(db, 'customers', this.user.uid)
      return onSnapshot(customerRef, res => {
        if (res.exists) {
          let data = res.data()
          this.$store.dispatch('setUserData', data)
          // console.log(res.data())
          this.publicListingId = data.connectedPublicListingId
          if (data.lineItems) {
            this.customerLineItems = data.lineItems
            this.lineItemsSize = data.lineItems.length
          }
        }

      })
    }
  },
  methods: {
    calcLineItemCost (item) {
      let cost = Number(item.cost)
      if (item.sublineItems) {
        item.sublineItems.forEach(subItem => {
          // console.log(+subItem.cost)
          cost += +subItem.cost
        })
      }
      cost = cost*item.finalCostMultiplier
      // console.log(cost)
      let costRounded = Number(cost).toFixed(2)
      return costRounded
    },
    bookOrder () {
      let quoteId = uuidv1()
      // this.$store.dispatch('setListingId', this.listingId)
      this.lineItemDialog = false
      console.log('route to smsAuth then on to orderBooking')
      this.$router.push(
          '/checkSmsAuth/'
          + this.publicListingId
          + '/quote'
          + '/createQuote/'
          + quoteId
      )
    },
    removeLineItem (lineItem) {
      console.log(lineItem)
      let index = this.customerLineItems.findIndex(local => {
        return local.id === lineItem.id
      })
      this.customerLineItems.splice(index, 1)
      this.user.lineItems = this.customerLineItems
      this.updatePreOrderData()
    },
    updatePreOrderData () {
      let user = this.user
      let db = this.$store.state.db
      //console.log(this.user)
      if (user.isAnonymous) {
        let anonRef = doc(db, 'anonUsers', user.uid)
        return updateDoc(anonRef, user)
      } else {
        let customerRef = doc(db, 'customers', user.uid)
        return updateDoc(customerRef, user)
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

